export enum StatisticsListColumnProperties {
  REGISTRATION_COUNT = 'registrationCount',
  FIRST_DEPOSIT_COUNT = 'firstDepositCount',
  ACTIVE_PLAYER_COUNT = 'activePlayerCount',
  DEPOSIT_SUM = 'depositSum',
  CASHOUT_SUM = 'cashoutSum',
  GGR = 'ggr',
  NGR = 'ngr',
  RTP = 'rtp',
  SECTION = 'section',
  BET_SUM = 'betSum',
  WIN_SUM = 'winSum',
}
